import { NodeItem, ConnectionItem } from "./types";

export const NODES: NodeItem[] = [
  {
    id: "center",
    label: "General Applications",
    x: 100,
    y: 100,
    type: "center",
    align: "middle",
    labelX: 100,
    labelY: 100,
  },
  // Capabilities
  {
    id: "intelligent-systems",
    label: "Intelligent Systems",
    x: 100,
    y: 60,
    type: "capability",
    align: "middle",
    labelX: 100,
    labelY: 51,
  },
  {
    id: "data-search-knowledge",
    label: "Data, Search & Knowledge",
    x: 140,
    y: 100,
    type: "capability",
    align: "start",
    labelX: 147,
    labelY: 101.5,
  },
  {
    id: "automation-operations",
    label: "Automation & Operations",
    x: 100,
    y: 140,
    type: "capability",
    align: "middle",
    labelX: 100,
    labelY: 150,
  },
  {
    id: "software-architecture-engineering",
    label: "Software Architecture & Engineering",
    x: 60,
    y: 100,
    type: "capability",
    align: "end",
    labelX: 53,
    labelY: 101.5,
  },
  // Industries
  {
    id: "energy",
    label: "Energy",
    x: 100,
    y: 22,
    type: "industry",
    align: "middle",
    labelX: 100,
    labelY: 16,
  },
  {
    id: "media-entertainment",
    label: "Media / Entertainment",
    x: 167,
    y: 61,
    type: "industry",
    align: "start",
    labelX: 172,
    labelY: 59,
  },
  {
    id: "agriculture",
    label: "Agriculture",
    x: 167,
    y: 139,
    type: "industry",
    align: "start",
    labelX: 172,
    labelY: 145,
  },
  {
    id: "enterprise",
    label: "Enterprise",
    x: 100,
    y: 178,
    type: "industry",
    align: "middle",
    labelX: 100,
    labelY: 185,
  },
  {
    id: "healthcare",
    label: "Healthcare",
    x: 33,
    y: 139,
    type: "industry",
    align: "end",
    labelX: 28,
    labelY: 145,
  },
  {
    id: "military",
    label: "Military",
    x: 33,
    y: 61,
    type: "industry",
    align: "end",
    labelX: 28,
    labelY: 59,
  },
];

export const CONNECTIONS: ConnectionItem[] = [
  // Capabilities to Center
  {
    from: "center",
    to: "intelligent-systems",
    type: "core",
    d: "M 100,100 L 100,60",
  },
  {
    from: "center",
    to: "data-search-knowledge",
    type: "core",
    d: "M 100,100 L 140,100",
  },
  {
    from: "center",
    to: "automation-operations",
    type: "core",
    d: "M 100,100 L 100,140",
  },
  {
    from: "center",
    to: "software-architecture-engineering",
    type: "core",
    d: "M 100,100 L 60,100",
  },

  // Capabilities to Industries
  // 1. Intelligent Systems
  {
    from: "intelligent-systems",
    to: "energy",
    type: "strong",
    d: "M 100,60 L 100,22",
  },
  {
    from: "intelligent-systems",
    to: "media-entertainment",
    type: "normal",
    d: "M 100,60 Q 134,50 167,61",
  },
  {
    from: "intelligent-systems",
    to: "agriculture",
    type: "normal",
    d: "M 100,60 Q 140,90 167,139",
  },
  {
    from: "intelligent-systems",
    to: "enterprise",
    type: "strong",
    d: "M 100,60 Q 40,110 100,178",
  },
  {
    from: "intelligent-systems",
    to: "healthcare",
    type: "strong",
    d: "M 100,60 Q 60,90 33,139",
  },
  {
    from: "intelligent-systems",
    to: "military",
    type: "strong",
    d: "M 100,60 Q 66,50 33,61",
  },

  // 2. Data & Search
  {
    from: "data-search-knowledge",
    to: "energy",
    type: "normal",
    d: "M 140,100 Q 140,60 100,22",
  },
  {
    from: "data-search-knowledge",
    to: "media-entertainment",
    type: "strong",
    d: "M 140,100 Q 153,80 167,61",
  },
  {
    from: "data-search-knowledge",
    to: "agriculture",
    type: "normal",
    d: "M 140,100 Q 153,120 167,139",
  },
  {
    from: "data-search-knowledge",
    to: "enterprise",
    type: "strong",
    d: "M 140,100 Q 140,140 100,178",
  },
  {
    from: "data-search-knowledge",
    to: "healthcare",
    type: "strong",
    d: "M 140,100 Q 100,132 33,139",
  },
  {
    from: "data-search-knowledge",
    to: "military",
    type: "normal",
    d: "M 140,100 Q 100,68 33,61",
  },

  // 3. Automation & Operations
  {
    from: "automation-operations",
    to: "energy",
    type: "strong",
    d: "M 100,140 Q 160,90 100,22",
  },
  {
    from: "automation-operations",
    to: "media-entertainment",
    type: "normal",
    d: "M 100,140 Q 140,110 167,61",
  },
  {
    from: "automation-operations",
    to: "agriculture",
    type: "strong",
    d: "M 100,140 Q 134,150 167,139",
  },
  {
    from: "automation-operations",
    to: "enterprise",
    type: "strong",
    d: "M 100,140 L 100,178",
  },
  {
    from: "automation-operations",
    to: "healthcare",
    type: "strong",
    d: "M 100,140 Q 66,150 33,139",
  },
  {
    from: "automation-operations",
    to: "military",
    type: "normal",
    d: "M 100,140 Q 60,110 33,61",
  },

  // 4. Software Architecture & Engineering
  {
    from: "software-architecture-engineering",
    to: "energy",
    type: "strong",
    d: "M 60,100 Q 60,60 100,22",
  },
  {
    from: "software-architecture-engineering",
    to: "media-entertainment",
    type: "strong",
    d: "M 60,100 Q 100,68 167,61",
  },
  {
    from: "software-architecture-engineering",
    to: "agriculture",
    type: "normal",
    d: "M 60,100 Q 100,132 167,139",
  },
  {
    from: "software-architecture-engineering",
    to: "enterprise",
    type: "strong",
    d: "M 60,100 Q 60,140 100,178",
  },
  {
    from: "software-architecture-engineering",
    to: "healthcare",
    type: "normal",
    d: "M 60,100 Q 47,120 33,139",
  },
  {
    from: "software-architecture-engineering",
    to: "military",
    type: "strong",
    d: "M 60,100 Q 47,80 33,61",
  },
];

export const SNIPPETS: Record<string, string> = {
  // NOTE: All snippets MUST remain under 90 characters to prevent vertical layout overflow
  default:
    "General Applications: Applied engineering for the intelligence era.",
  center:
    "General Applications: We build software, AI, search, and operational systems.",
  "intelligent-systems":
    "Intelligent Systems: Applied AI, retrieval-backed workflows, and governed automation.",
  "data-search-knowledge":
    "Data, Search & Knowledge: Hybrid retrieval, canonical models, and search quality.",
  "automation-operations":
    "Automation & Operations: Workflow automation, exception handling, and visibility.",
  "software-architecture-engineering":
    "Software Architecture & Engineering: Architecture, delivery foundations, and evolution.",
  energy:
    "Energy: Mission-critical workflow, information, and control systems for power grids.",
  agriculture:
    "Agriculture: Production planning and decision-support tools for growing operations.",
  enterprise:
    "Enterprise: Data platforms, search systems, compliance engines, and internal tooling.",
  healthcare:
    "Healthcare: Operational software and compliant products for regulated care workflows.",
  military:
    "Military: High-security data, maintenance, and readiness platforms for defense.",
  "media-entertainment":
    "Media/Entertainment: Asset and workflow engines that keep production teams moving.",
};

export const NODE_LINKS: Record<string, string> = {
  center: "/about",
  "intelligent-systems": "/capabilities/intelligent-systems",
  "data-search-knowledge": "/capabilities/data-search-knowledge",
  "automation-operations": "/capabilities/automation-operations",
  "software-architecture-engineering":
    "/capabilities/software-architecture-engineering",
  energy: "/industries/energy",
  "media-entertainment": "/industries/media-entertainment",
  agriculture: "/industries/agriculture",
  enterprise: "/industries/enterprise",
  healthcare: "/industries/healthcare",
  military: "/industries/military",
};

export const DEFAULT_ACTIVE = "center";

export const VISUAL_CONFIG = {
  enableRadarRotation: true,
  radarSpeedClockwise: "160s",
  radarSpeedCounterClockwise: "110s",

  enablePacketFlow: true,
  packetDashLength: 6,
  packetDashGap: 160,
  packetFlowDuration: "3.2s",

  enableAutoTour: true,
  autoTourIdleDelay: 6000,
  autoTourInterval: 3500,
};
